































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  inject: ['form'],
})
export default class UnifyFormInput extends Vue {
  @Prop({
    type: String,
  })
  public readonly autocomplete!: string

  @Prop({
    type: String,
  })
  public readonly autofill!: string

  @Prop({
    type: Function,
  })
  public readonly blur?: (value: any, control: string) => any

  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly dirtyAfterBlur!: boolean

  @Prop({
    type: Function,
  })
  public readonly normalize?: (value: any, control: string) => any

  @Prop({
    type: Number,
  })
  public readonly maxlength?: number

  @Prop({
    type: String,
  })
  public readonly placeholder!: string

  @Prop({
    type: Number,
  })
  public readonly step!: number

  @Prop({
    default: 'text',
    type: String,
  })
  public readonly type!: string

  @Prop({
    type: [String],
  })
  public readonly value!: string

  public readonly form!: FormGroup<any>

  private blurred: boolean = false

  public get controlValue() {
    return this.formControl.$model
  }

  public set controlValue(value: any) {
    this.formControl.$model = value
  }

  public get dirty() {
    let dirty: boolean

    if (this.dirtyAfterBlur) {
      dirty = this.blurred && this.formControl.$dirty
    } else {
      dirty = this.formControl.$dirty
    }

    return dirty
  }

  public get error() {
    return this.dirty && this.invalid
  }

  public get formControl() {
    return this.form.field(this.control)
  }

  public get invalid() {
    return this.formControl.$invalid
  }

  public get required() {
    return this.formControl.hasOwnProperty('required')
  }

  public onBlur(): void {
    this.blurred = true

    if (this.blur != null) {
      this.controlValue = this.blur(this.controlValue, this.control)
    }
  }

  public onInput(): void {
    if (this.normalize != null) {
      this.controlValue = this.normalize(this.controlValue, this.control)
    }
  }

  public update(event: InputEvent) {
    const target = event.target as HTMLInputElement

    this.$emit('input', target.value)
  }
}
